import React from 'react';
import PropTypes from 'prop-types';
import {
  Step,
  StepNumber,
  StepContent,
  StepContentTitle,
  StepContentText,
  ModalOpenLink,
  Image
} from 'products/nomad_insurance/views/Profile/ClaimsOld/styled';
import stepThreeImage from 'products/nomad_insurance/assets/img/claims/step-three-copy.svg';

const StepThree = ({ handleModalOpen }) => {
  return (
    <Step>
      <StepNumber>
        <span>3</span>
      </StepNumber>
      <StepContent>
        <Image>
          <img src={stepThreeImage} alt="Illustration of process calendar" />
        </Image>
        <StepContentTitle>Follow the process</StepContentTitle>
        <StepContentText>
          Your claim should take less than 45 business days to be processed. You can
          follow the process on WorldTrips' Member Portal.{' '}
          <ModalOpenLink onClick={handleModalOpen}>Click here</ModalOpenLink> to see
          instructions.
        </StepContentText>
      </StepContent>
    </Step>
  );
};

StepThree.propTypes = {
  handleModalOpen: PropTypes.func
};

export default StepThree;
